import { types } from 'mobx-state-tree'
import { CountryMarkModel } from './CountryMarkModel'

export const MaterialCountriesModel = types.model('MaterialCountriesModel', {
  id: types.number,
  name: types.string,
  countryMarks: types.array(types.maybeNull(CountryMarkModel)),
})
